<template>
  <footer class="version-footer">
    <span>
      Version: {{ adminV2Service }}
    </span>
    <span>,</span>
    <span>
      Instance: {{ adminV2ServiceInstance }}
    </span>
    <button @click="showDetails = !showDetails" class="details-btn">
      {{ showDetails ? 'Hide details' : 'More info' }}
    </button>

    <!-- Expanded details -->
    <div v-if="showDetails" class="details-box">
      <ul>
        <li v-for="(value, key) in versions" :key="key">
          <strong>{{ key }}</strong>: {{ value }}
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import {VueApp} from "@/main";

export default {
  name: "VersionFooter",
  data() {
    return {
      versions: {},
      showDetails: false,
      adminV2Service: window.runtimeConfig.VUE_APP_EBAHOLASH_ADMIN_V2_SERVICE || "unknown",
      adminV2ServiceInstance: window.runtimeConfig.VUE_APP_INSTANCE_NAME || "unknown"
    };
  },
  computed: {
    mainVersion() {
      // pick one main version (you can adjust logic here)
      return this.versions.EBAHOLASH_ADMIN_V2_SERVICE
          || this.versions.EBAHOLASH_SERVER_V2_SERVICE
          || "N/A";
    }
  },
  mounted() {
    VueApp.$http.get("/meta")
        .then(response => {
          this.versions = response.data;
        })
        .catch(err => {
          console.error("Failed to load versions:", err);
        });
  }
};
</script>

<style scoped>
.version-footer {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 6px 12px;
  background: #f8f9fa;
  //border-top: 1px solid #ddd;
  font-size: 12px;
  //color: #555;
  z-index: 99999;
}
.details-btn {
  margin-left: 8px;
  font-size: 12px;
  background: none;
  border: none;
  //color: #007bff;
  cursor: pointer;
}
.details-box {
  margin-top: 6px;
  padding: 6px;
  //background: #fff;
  //border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
}
</style>
